module.exports = __webpack_public_path__ + "static/a45a549b-9648-4f82-805e-51b7954223c9-700.d2b20716.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/oval-vase-evening-sky/a45a549b-9648-4f82-805e-51b7954223c9-700.jpg
// module id = 1017
// module chunks = 168707334958949